import { render, staticRenderFns } from "./dataCompanyForm.vue?vue&type=template&id=375e10ba&scoped=true&"
import script from "./dataCompanyForm.vue?vue&type=script&lang=js&"
export * from "./dataCompanyForm.vue?vue&type=script&lang=js&"
import style0 from "./dataCompanyForm.vue?vue&type=style&index=0&id=375e10ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "375e10ba",
  null
  
)

export default component.exports